<template>
  <div>
    <Jumbotron title="Become A Guider" />

    <!-- DESKTOP -->
    <b-container class="d-none d-sm-block">
      <b-row class="m-3 p-4">
        <b-col cols="10" offset="1" class="text-center">
          <video controls autoplay style="border-radius: 15px; max-width: 100%;">
            <source :src="require('@/assets/video/become-a-guider.mp4')" type="video/mp4" >
          </video>
        </b-col>

        <b-col>
          <p class="mt-3 text-justify">
            &emsp;Kalian orang indonesia yang sedang berkuliah diluar negeri dan suka jalan-jalan? Kamu bisa mendaftarkan dirimu menjadi Guider kami dengan beberapa langkah mudah.
          </p>
          <p>
            <ol>
              <li>Kunjungi website kami di <a href="https://www.starguides.co/">www.starguides.co</a>.</li>
              <li>Klik "Create an Account", Lalu isi data diri anda.</li>
              <li>Konfirmasi email kamu dengen membuka link yang kami kirim via email.</li>
              <li>Lalu login di <a href="https://capt.starguides.co/">capt.starguides.co</a> dan lakukan pembayaran biaya pendaftaran melalui metode yang ada.</li>
              <li>Biaya ini sudah termasuk biaya atribut (<i>scarf</i>) yang harus kamu kenakan ketika menjadi Guider.</li>
              <li>Kamu akan mendapatkan email yang berisi detail pembayaran kamu.</li>
              <li>Selamat! Akun kamu telah terdaftar dan aktif dalam sistem kami.</li>
            </ol>
          </p>
          <p class="mt-3 text-justify">
            &emsp;Jika kamu masih memiliki pertanyaan kamu dapat langsung menghubungi di nomor +628111774779 (telpoon, sms, WA) atau melalui email Guiders Engagement kami di <a href="mailto:guiders@starguides.co">guiders@starguides.co</a>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- MOBILE -->
    <b-container class="d-block d-sm-none">
      <b-row class="m-1 px-1 py-3">

        <b-col cols="12">
          <video controls autoplay style="border-radius: 15px; max-width: 100%;">
            <source :src="require('@/assets/video/become-a-guider.mp4')" type="video/mp4" >
          </video>
        </b-col>

        <b-col>
          <p class="mt-3 text-justify">
            &emsp;Kalian orang indonesia yang sedang berkuliah diluar negeri dan suka jalan-jalan? Kamu bisa mendaftarkan dirimu menjadi Guider kami dengan beberapa langkah mudah.
          </p>
          <p>
            <ol>
              <li>Kunjungi website kami di <a href="https://www.starguides.co/">www.starguides.co</a>.</li>
              <li>Klik "Create an Account", Lalu isi data diri anda.</li>
              <li>Konfirmasi email kamu dengen membuka link yang kami kirim via email.</li>
              <li>Lalu login di <a href="https://capt.starguides.co/">capt.starguides.co</a> dan lakukan pembayaran biaya pendaftaran melalui metode yang ada.</li>
              <li>Biaya ini sudah termasuk biaya atribut (<i>scarf</i>) yang harus kamu kenakan ketika menjadi Guider.</li>
              <li>Kamu akan mendapatkan email yang berisi detail pembayaran kamu.</li>
              <li>Selamat! Akun kamu telah terdaftar dan aktif dalam sistem kami.</li>
            </ol>
          </p>
          <p class="mt-3 text-justify">
            &emsp;Jika kamu masih memiliki pertanyaan kamu dapat langsung menghubungi di nomor +628111774779 (telpoon, sms, WA) atau melalui email Guiders Engagement kami di <a href="mailto:guiders@starguides.co">guiders@starguides.co</a>
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
import Jumbotron from '@/components/Jumbotron'

export default {
  name: 'BecomeAGuider',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  }
}
</script>

<style scoped>
.sg-title {
  font-weight: 900;
}
@media screen and (max-width: 767px) {
  .sg-title {
    font-size: 30px;
  }
}
@media screen and (max-width: 1023px) and (min-width: 768px) {
  .sg-title {
    font-size: 40px;
  }
}
@media screen and (max-width: 1980px) and (min-width: 1023px) {
  .sg-title {
    font-size: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Static/BecomeAGuider.vue